export const whyLiftBlur = [
	{
		icon: '✅',
		title: 'whyLiftData.title1',
		subtitle: 'whyLiftData.subtitle1',
	},
	{
		icon: '✅',
		title: 'whyLiftData.title2',
		subtitle: 'whyLiftData.subtitle2',
	},
	{
		icon: '✅',
		title: 'whyLiftData.title3',
		subtitle: 'whyLiftData.subtitle3',
	},
	{
		icon: '✅',
		title: 'whyLiftData.title4',
		subtitle: 'whyLiftData.subtitle4',
	},
];
